import React, { Component } from 'react';
import moment from 'moment';

class DonorDetails extends Component {
    _renderColumn = ({ title, content }) => { 
        return (
            <div className="flex-column">
                <div className="flex-title">{title}</div>
                <div className="flex-content">{content}</div>
            </div>
        );
    }
    render() {
        const { donorId, donorState: { donorsById } } = this.props;
        const donor = donorsById[donorId];
        let gender;
        switch (donor.gender.toUpperCase()) {
            case 'F':
                gender = 'Female';
                break;
            case 'M':
                gender = 'Male';
                break;
            default:
                break;   
        }
        return (
            <div className="panel-details">
                <div className="flex-row bordered">
                    { this._renderColumn({ title: 'Name', content: `${donor.first_name} ${donor.middle_name} ${donor.last_name}` }) }
                    { this._renderColumn({ title: 'Gender', content: gender }) }
                </div>
                <div className="flex-row bordered">
                    { this._renderColumn({ title: 'Street Address', content: donor.street_address }) }
                    { this._renderColumn({ title: 'City', content: donor.city_of_residence }) }
                </div>
                <div className="flex-row bordered">
                    { this._renderColumn({ title: 'State or Province', content: donor.state_or_province }) }
                    { this._renderColumn({ title: 'Country', content: donor.country_of_residence }) }
                </div>
                <div className="flex-row bordered">
                    { this._renderColumn({ title: 'Postal Code', content: donor.postal_code }) }
                    { this._renderColumn({ title: 'Local Church', content: donor.local_church }) }
                </div>
                <div className="flex-row bordered">
                    { this._renderColumn({ title: 'Phone', content: donor.phone }) }
                    { this._renderColumn({ title: 'Email', content: donor.email }) }
                </div>
                <div className="flex-row bordered">
                    { this._renderColumn({ title: 'MEF Sign Up Date', content: moment(donor.mef_signup_date).format('ddd, MMM Do, YYYY') }) }
                    { this._renderColumn({ title: 'Notes', content: donor.notes }) }
                </div>
            </div>
        );
    }
}

export default DonorDetails;


// WEBPACK FOOTER //
// ./src/components/main/dashboard/panel/donor/DonorDetails.jsx